import HorizontalRule from 'components/HorizontalRule';
import React from 'react';
import { Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import moment from 'moment';
import ShiftSummary from './ShiftSummary';
import ShiftActions from './ShiftActions';
import { DeleteButton } from 'components/V2/Buttons';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import DeleteDayModal from 'components/V2/ConfirmationModal/DeleteDayModal';
import { sortBy } from 'lodash';

const DaysListItem = (props) => {
  const [open, setOpen] = React.useState(props.open);
  const [openDeleteDayModal, setOpenDeleteDayModal] = React.useState(false);
  const { idx, date, shifts, rateTypes, editMode, days } = props;

  const toggleDeleteDayModal = () =>
    setOpenDeleteDayModal(!openDeleteDayModal)

  const onDeleteDay = () => props.removeMultipleShifts(shifts.flatMap(({ idx }) => idx));

  return (
    <li className="days-list-item" key={`li-${idx}`}>
      <Card key={idx} className="border-0">
        <CardHeader className="day-header">
          <Button color="link" className="day-btn gotham-bold-font" onClick={() => setOpen(!open)}>
            <i className={`arrow fas fa-chevron-${open ? 'down' : 'right'}`}></i>
            Day {idx + 1}: &nbsp;&nbsp;
            {moment(date).format('MM/DD/YY')}
          </Button>
          {days.length > 1 && (
            <React.Fragment>
              <DeleteButton className="float-right" onClick={toggleDeleteDayModal}>
                DELETE DAY
              </DeleteButton>
              {editMode ? <DeleteDayModal
                isOpen={openDeleteDayModal}
                title="Delete day"
                body={`Deleting this day on ${moment(date).format('MM/DD/YYYY')} will remove athletic trainers who applied or confirmed to work.`}
                toggle={toggleDeleteDayModal}
                onDelete={onDeleteDay}
                items={sortBy(shifts.filter(shift => moment(shift.startDate).isSame(moment(date))), shift => moment(shift.startTime))}
                user={props.user}
                eventName={props.eventName}
              /> : <ConfirmationModal
                isOpen={openDeleteDayModal}
                toggle={toggleDeleteDayModal}
                title="Delete Day"
                body={`Are you sure you want to delete this day: ${moment(date).format('MM/DD/YYYY')}?`}
                onSave={onDeleteDay}
                onCancel={toggleDeleteDayModal}
                confirmText="Delete"
                cancelText="Go Back"
              />}
            </React.Fragment>

          )}
        </CardHeader>
        <HorizontalRule dashed={open} margin="0" />
        <Collapse isOpen={open}>
          <CardBody className={`py-1`}>
            {shifts.map((shift, mapIdx) => (
              <div className="shift shift-sum-item" key={shift.idx} id={`s-${idx}`}>
                <div className="shift-name gotham-bold-font">{`Shift ${mapIdx + 1}`}</div>
                <ShiftSummary shift={shift} rateTypes={rateTypes} editMode={editMode} />
                <ShiftActions
                  {...props}
                  idx={mapIdx}
                  shift={shift}
                  canDelete={props.canDeleteShift}
                />
              </div>
            ))}
          </CardBody>
          <HorizontalRule margin="0" />
        </Collapse>
      </Card>
    </li>
  );
};

export default DaysListItem;
